@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: container from "../../styles/composable/layout.module.css";

    // nested for specificity
    .grid {
        row-gap: var(--spacer-40);
    }
}

.grid {
    composes: grid from "../../styles/composable/layout.module.css";
    composes: listReset from "../../styles/composable/utility.module.css";
}

.gridItem {
    grid-column: span 4;

    @media ($below-mobile) {
        grid-column: span 2;
    }

    > * {
        display: block;
    }
}

.loadMoreContainer {
    margin-top: var(--spacer-40);
    text-align: center;
}
